import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M12.295 2.31a.75.75 0 0 0-.59 0l-7 3A.75.75 0 0 0 4.25 6v9a.75.75 0 0 0 .022.182c.402 1.607 1.56 2.993 2.923 4.079 1.374 1.093 3.032 1.942 4.57 2.451a.75.75 0 0 0 .47 0c1.538-.51 3.196-1.358 4.57-2.451 1.363-1.086 2.521-2.472 2.923-4.08A.747.747 0 0 0 19.75 15V6a.75.75 0 0 0-.455-.69l-7-3ZM5.75 11.75v3.153c.31 1.13 1.177 2.227 2.38 3.184a13.552 13.552 0 0 0 3.12 1.83V11.75h-5.5Zm7 8.167a13.553 13.553 0 0 0 3.12-1.83c1.203-.957 2.07-2.054 2.38-3.184V11.75h-5.5v8.167Zm5.5-9.667V6.495l-5.5-2.358v6.113h5.5Zm-7-6.113v6.113h-5.5V6.495l5.5-2.358Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  c
];
function r(a, d) {
  return e(), t("svg", l, [...n]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
